import request from '@/utils/request';

export const EMAIL_VALIDATION_REPORTS = 'EMAIL_VALIDATION_REPORTS';

export const fetchEmailValidationReports =
  ({ limit, page, status, order, order_field }) =>
  async dispatch => {
    const response = await request({
      path: `/v1/admin/email_validation_reports`,
      query: { limit, page, status, order, order_field }
    });
    if (response.data) {
      dispatch({
        payload: response,
        type: EMAIL_VALIDATION_REPORTS
      });
    }
    return response;
  };
